import clsx from 'clsx';
import mapValues from 'lodash/mapValues';
import Link from 'next/link';
import React from 'react';
import { Breadcrumbs, CompaniesBlock } from '../_shared';
import { CartIcon, HammerIcon, MonitorIcon } from '../Icons';
import { rootLinks } from '../Links';
import { Logistic } from './SectionImage';
import { Materials } from './SectionImage';
import { Pharmacy } from './SectionImage';
import { Products } from './SectionImage';
import { Services } from './SectionImage';
import styles from './Sections.module.scss';
import { SectionsProps } from './Sections.type';

const getSectionHref = (section: string) => ({
    pathname: rootLinks.purchases.url,
    query: { section },
});

export const sectionsByName = mapValues(
    {
        fz223: {
            name: 'fz-223',
            title: '223-Ф3',
        },
        commercial: {
            name: 'commercial',
            title: 'Коммерческие закупки',
        },
        eShop: {
            name: 'e-shop',
            title: 'Электронный магазин',
        },
        constructionMaterials: {
            name: 'construction-materials',
            title: 'Строительные материалы',
        },
        constructionServices: {
            name: 'construction-services',
            title: 'Строительно-монтажные работы',
        },
        food: {
            name: 'food',
            title: 'Продукты питания',
        },
        logistics: {
            name: 'logistics',
            title: 'Логистика',
        },
        medicine: {
            name: 'medicine',
            title: 'Медицина',
        },
    },
    (section) => ({
        ...section,
        href: getSectionHref(section.name),
    })
);

export const sections = Object.values(sectionsByName);

export const Sections: React.FC<SectionsProps> = ({
    hoverLink,
    handleHoverLink,
    orgSections,
}) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1 className={styles.title}>Секции ЭТП</h1>
                <div className={styles.links}>
                    <Link href={sectionsByName.fz223.href}>
                        <a className={clsx(styles.paper, styles.blue)}>
                            <div className={styles.paperText}>
                                {sectionsByName.fz223.title}
                            </div>
                            <HammerIcon className={styles.paperIcon} />
                            <div className={styles.left} />
                            <div className={styles.right} />
                        </a>
                    </Link>
                    <Link href={sectionsByName.commercial.href}>
                        <a className={clsx(styles.paper, styles.violet)}>
                            <div className={styles.paperText}>
                                {sectionsByName.commercial.title}
                            </div>
                            <CartIcon className={styles.paperIcon} />
                            <div className={styles.left} />
                            <div className={styles.right} />
                        </a>
                    </Link>
                    <Link href={sectionsByName.eShop.href}>
                        <a className={clsx(styles.paper, styles.green)}>
                            <div className={styles.paperText}>
                                {sectionsByName.eShop.title}
                            </div>
                            <MonitorIcon className={styles.paperIcon} />
                            <div className={styles.left} />
                            <div className={styles.right} />
                        </a>
                    </Link>
                </div>
                <div className={styles.title}>Отраслевые секции</div>
                <div className={styles.sections}>
                    <div className={styles.sectionsImages}>
                        <Link href={sectionsByName.constructionMaterials.href}>
                            <a
                                className={clsx(
                                    styles.sectionsImage,
                                    hoverLink === 1 && styles.hovered
                                )}
                            >
                                <Materials />
                            </a>
                        </Link>
                        <Link href={sectionsByName.constructionServices.href}>
                            <a
                                className={clsx(
                                    styles.sectionsImage,
                                    hoverLink === 2 && styles.hovered
                                )}
                            >
                                <Services />
                            </a>
                        </Link>
                        <Link href={sectionsByName.food.href}>
                            <a
                                className={clsx(
                                    styles.sectionsImage,
                                    hoverLink === 3 && styles.hovered
                                )}
                            >
                                <Products />
                            </a>
                        </Link>
                        <Link href={sectionsByName.logistics.href}>
                            <a
                                className={clsx(
                                    styles.sectionsImage,
                                    hoverLink === 4 && styles.hovered
                                )}
                            >
                                <Logistic />
                            </a>
                        </Link>
                        <Link href={sectionsByName.medicine.href}>
                            <a
                                className={clsx(
                                    styles.sectionsImage,
                                    hoverLink === 5 && styles.hovered
                                )}
                            >
                                <Pharmacy />
                            </a>
                        </Link>
                    </div>

                    <div className={styles.sectionsLinks}>
                        <Link href={sectionsByName.constructionMaterials.href}>
                            <a
                                className={styles.sectionsLink}
                                onMouseEnter={() => handleHoverLink(1)}
                                onMouseLeave={() => handleHoverLink(null)}
                            >
                                {sectionsByName.constructionMaterials.title}
                            </a>
                        </Link>

                        <Link href={sectionsByName.constructionServices.href}>
                            <a
                                className={styles.sectionsLink}
                                onMouseEnter={() => handleHoverLink(2)}
                                onMouseLeave={() => handleHoverLink(null)}
                            >
                                {sectionsByName.constructionServices.title}
                            </a>
                        </Link>

                        <Link href={sectionsByName.food.href}>
                            <a
                                className={styles.sectionsLink}
                                onMouseEnter={() => handleHoverLink(3)}
                                onMouseLeave={() => handleHoverLink(null)}
                            >
                                {sectionsByName.food.title}
                            </a>
                        </Link>

                        <Link href={sectionsByName.logistics.href}>
                            <a
                                className={styles.sectionsLink}
                                onMouseEnter={() => handleHoverLink(4)}
                                onMouseLeave={() => handleHoverLink(null)}
                            >
                                {sectionsByName.logistics.title}
                            </a>
                        </Link>

                        <Link href={sectionsByName.medicine.href}>
                            <a
                                className={styles.sectionsLink}
                                onMouseEnter={() => handleHoverLink(5)}
                                onMouseLeave={() => handleHoverLink(null)}
                            >
                                {sectionsByName.medicine.title}
                            </a>
                        </Link>
                    </div>
                </div>
                <CompaniesBlock
                    orgSections={orgSections}
                    title="Секции заказчиков"
                />
            </div>
        </div>
    );
};
